import * as React from "react";

export const IconSearchBlue = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_20165_770)">
      <path
        d="M13.4167 11.6667H12.7583L12.525 11.4417C13.3417 10.4917 13.8333 9.25833 13.8333 7.91667C13.8333 4.925 11.4083 2.5 8.41667 2.5C5.425 2.5 3 4.925 3 7.91667C3 10.9083 5.425 13.3333 8.41667 13.3333C9.75833 13.3333 10.9917 12.8417 11.9417 12.025L12.1667 12.2583V12.9167L16.3333 17.075L17.575 15.8333L13.4167 11.6667ZM8.41667 11.6667C6.34167 11.6667 4.66667 9.99167 4.66667 7.91667C4.66667 5.84167 6.34167 4.16667 8.41667 4.16667C10.4917 4.16667 12.1667 5.84167 12.1667 7.91667C12.1667 9.99167 10.4917 11.6667 8.41667 11.6667Z"
        fill={props.color ?? "#185DE3"}
      />
    </g>
    <defs>
      <clipPath id="clip0_20165_770">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
